import { IContainer } from '../../interface/container';
import {
    bindMediaManager,
    bindAuthManager,
    bindUserStateManager,
    unbindMediaManager,
    unbindAuthManager,
    unbindUserStateManager,
} from '../interface/bind';
import mediaInst from '../impl/media.bind';
import authInst from '../impl/auth.bind';
import userStateInst from '../impl/userState.bind';

function bind(container: IContainer) {
    bindMediaManager(mediaInst(container), container);
    bindAuthManager(authInst(container), container);
    bindUserStateManager(userStateInst(container), container);
}

function unbind(container: IContainer) {
    unbindMediaManager(container);
    unbindAuthManager(container);
    unbindUserStateManager(container);
}

const module = {
    bind,
    unbind,
};

export default module;
